import React, { useCallback, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { searchCustomersByCompanyNameThunk, searchCustomersByNameThunk } from '../../../../redux/thunk/customer'
import { setCustomersByCompanyName, setCustomersByName } from '../../../../redux/action/customer'
import { filterSearchString } from '../../../../helper/filterSearchString'
import { capitalize } from '../../../../helper'
import { CustomerNameContainer, CustomerNameWrapper } from '../index.styled'
import AutocompleteInput from '../../../Elements/inputs/AutocompleteInput'
import CheckBoxInputControlled from '../../../Elements/inputs/CheckboxInput/controlled'
import { CompanyNameAutocompleteItem, NameAutocompleteItem } from '../autocomplete/items'

const NAME_EVENT_Z_INDEX = 11
const COMPANY_NAME_EVENT_Z_INDEX = 88

const CustomerNameInputs = ({
	register, errors, watch, showForm, handleF2, handleEscape, handleCustomerClick, returnZIndex,
}) => {
	const customersByName = useSelector(store => store.customerStore.customersByName)
	const customersByCompanyName = useSelector(store => store.customerStore.customersByCompanyName)
	const [isFirma, setIsFirma] = useState(false)
	const { t } = useTranslation()
	const dispatch = useDispatch()
	const watchPhone = watch('phoneNumber')

	const onAutoCompleteCustomerName = useCallback(value => {
		if (value && !watchPhone) {
			dispatch(searchCustomersByNameThunk(value))
		} else {
			dispatch(setCustomersByName(null))
		}
	}, [watchPhone, dispatch])

	const filterName = useCallback(v => {
		const replaceForbiddenSymbol = filterSearchString(v)
		return capitalize(replaceForbiddenSymbol)
	}, [])

	const setItemsByName = useCallback(value => {
		dispatch(setCustomersByName(value))
	}, [dispatch])

	const onAutoCompleteCompanyName = useCallback(value => {
		if (value && isFirma) {
			dispatch(searchCustomersByCompanyNameThunk(value))
		} else {
			dispatch(setCustomersByCompanyName(null))
		}
	}, [dispatch, isFirma])

	const filterCompanyName = useCallback(v => {
		return filterSearchString(v)
	}, [])

	const setItemsByCompanyName = useCallback(value => {
		dispatch(setCustomersByCompanyName(value))
	}, [dispatch])

	const toggleFirmaShow = useCallback(() => {
		setIsFirma(!isFirma)
	}, [isFirma])

	return (
		<CustomerNameContainer className={isFirma ? 'columns' : ''}>
			<CustomerNameWrapper className={!showForm ? 'lf-hidden name' : ''}>
				<AutocompleteInput testId="customer-name"
													 name="name"
													 tabIndex="903"
													 zIndex={NAME_EVENT_Z_INDEX}
													 returnZIndex={returnZIndex}
													 label={t('AddOrder.Client.form.Name')}
													 errors={errors}
													 register={register}
													 options={{
														 required: t('app.validation.required'),
													 }}
													 items={customersByName}
													 Item={NameAutocompleteItem}
													 watch={watch}
													 onAutoComplete={onAutoCompleteCustomerName}
													 filter={filterName}
													 setItems={setItemsByName}
													 onClick={handleCustomerClick}
													 onReset={handleEscape}
													 onSubmit={handleF2}>
					<CheckBoxInputControlled id="firma-id" label={t('AddOrder.Client.form.Company')} className="firma-id"
																	 testId="is-firma" checked={isFirma} onChange={toggleFirmaShow} />
				</AutocompleteInput>
			</CustomerNameWrapper>
			{isFirma &&
				<CustomerNameWrapper className={!showForm ? 'lf-hidden name' : ''}>
					<AutocompleteInput testId="customer-company"
														 name="companyName"
														 tabIndex="904"
														 zIndex={COMPANY_NAME_EVENT_Z_INDEX}
														 returnZIndex={returnZIndex}
														 label={t('AddOrder.Client.form.Company')}
														 errors={errors}
														 register={register}
														 items={customersByCompanyName}
														 Item={CompanyNameAutocompleteItem}
														 watch={watch('companyName')}
														 onAutoComplete={onAutoCompleteCompanyName}
														 filter={filterCompanyName}
														 setItems={setItemsByCompanyName}
														 onClick={handleCustomerClick}
														 onReset={handleEscape}
														 onSubmit={handleF2} />
				</CustomerNameWrapper>}
		</CustomerNameContainer>
	)
}

CustomerNameInputs.displayName = 'CustomerNameInputs'
export default CustomerNameInputs
